import React from 'react';
import { Link } from 'react-router-dom';
import { VUKZ } from '../../theme/vukzTheme';
import { ArrowLeft } from 'lucide-react';
import { getSportGradient } from '../../config/sportsConfig';

/**
 * StudyHeroSection — Hero banner para estudos interativos
 *
 * Props:
 *   emoji        — Emoji decorativo (ex: '🏊')
 *   title        — Título do estudo
 *   description  — Descrição curta (1-2 frases)
 *   stats        — Array de {value, label} para os cards de resumo
 *   backLink     — URL para voltar (default: '/estudos')
 *   backLabel    — Label do botão voltar (default: 'Voltar para Estudos')
 *   category     — Sport category for gradient (ex: 'natacao', 'futebol')
 */
const StudyHeroSection = ({
  emoji = '📊',
  title,
  description,
  stats = [],
  backLink = '/estudos',
  backLabel = 'Voltar para Estudos',
  category,
}) => (
  <div
    className="py-12 px-4"
    style={{
      background: category
        ? getSportGradient(category)
        : `linear-gradient(135deg, ${VUKZ.primary} 0%, ${VUKZ.primaryDark || '#000000'} 100%)`,
    }}
  >
    <div className="max-w-6xl mx-auto">
      <Link
        to={backLink}
        className="inline-flex items-center gap-2 text-sm font-medium text-white/60 hover:text-white transition-colors mb-4"
      >
        <ArrowLeft className="w-4 h-4" /> {backLabel}
      </Link>

      <h1 className="text-3xl md:text-4xl font-black text-white mb-3">
        {emoji} {title}
      </h1>
      {description && (
        <p className="text-base text-white/70 max-w-3xl">{description}</p>
      )}

      {stats.length > 0 && (
        <div className="flex flex-wrap gap-4 mt-6">
          {stats.map((s, i) => (
            <div key={i} className="bg-white/10 rounded-xl px-4 py-2 backdrop-blur-sm">
              <div className="text-xl font-black text-white">
                {typeof s.value === 'number' ? s.value.toLocaleString('pt-BR') : s.value}
              </div>
              <div className="text-xs text-white/50">{s.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default StudyHeroSection;
